import { useMemo } from 'react';
//import { Note } from '../../../../../model/models';
//import { notebookService } from '../../../../../App';



const NoteView = ({note}) => {
  // Memoize the HTML object to prevent recreation on every render (rendering-performance)
  const htmlContent = useMemo(() => ({ __html: note?.text || '' }), [note?.text]);

  return (
    <>
    <div className='relative h-100'>
    <div className='all-0'>
        <div className='note-prev-view rounded-3 m-1 font-10 rounded p-3 relative scroll-auto h-100'>
        {/* <div>{ note?.text ? parse(`${note.text}`) : ''}</div> */}
        <div dangerouslySetInnerHTML={htmlContent}></div>
        </div>
    </div>
    </div>
    </>
  )
}

export default NoteView
